import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiSend } from 'react-icons/fi';
import Whatsapp from '../../../../../../components/Whatsapp';
import { authTitle } from '../../../../../../config';
import { FaMailBulk, FaPaperPlane, FaUser } from 'react-icons/fa';
import { useLoading } from 'src/hooks/LoadingHook';
import { useModal } from 'src/hooks/Modal';
import sleep from 'src/utils/sleep';
import { Form } from '@unform/web';
import Input from 'src/components/Forms/Input';


interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ContactModule({

  lineData,

}: ICreateModule): JSX.Element {

  const { addLoading, removeLoading } = useLoading();
  const { addModal } = useModal();
  const { addToast } = useToast();
  const sendMail = async () => {


    try {
      await api.post(`/send-invitation-to-user/${lineData?.invitation_id}/${lineData?.user_hash}/yes`);

      addToast({ title: `1/ 1 - Enviado com sucesso`, type: 'success' });

    }
    catch (err) {

      addToast({ title: `1/ 1 - ${err?.response?.data?.message || 'Erro ao enviar'} `, type: 'error' })
    }

    return;

  }

  const sendUserContent = async (data) => {


    const students = await api.get('students', { params: { where: { user_hash: lineData?.user_hash } } });

    if (!students?.data?.rows?.[0]) {
      addToast({ title: 'Erro ao identificar usuário', type: 'error' });
      return;
    }


    const student = students?.data?.rows?.[0];

    if (lineData?.email !== student?.email) {
      addToast({ title: 'Erro ao confirmar base', type: 'error' });
      return;
    }
    addLoading({ title: 'Carregando', key: 'loading' })
    await api.put(`students/${student?._id?.toString()}/name`, { name: data?.name });
    await api.put(`students/${student?._id?.toString()}/email`, { email: data?.email });
    await api.put(`students/${student?._id?.toString()}/phone`, { phone: data?.phone });
    await api.put(`students/${student?._id?.toString()}/company`, { company: data?.company });
    await api.put(`students/${student?._id?.toString()}/position`, { position: data?.position });
    await api.put(`students/${student?._id?.toString()}/category_id`, { category_id: data?.category_id });
    await api.put(`students/${student?._id?.toString()}/table`, { table: data?.table });

    await api.put(`invitation-confirmation/${lineData?._id?.toString()}/name`, { name: data?.name });
    await api.put(`invitation-confirmation/${lineData?._id?.toString()}/email`, { email: data?.email });
    await api.put(`invitation-confirmation/${lineData?._id?.toString()}/phone`, { phone: data?.phone });
    await api.put(`invitation-confirmation/${lineData?._id?.toString()}/company`, { company: data?.company });
    await api.put(`invitation-confirmation/${lineData?._id?.toString()}/position`, { position: data?.position });
    await api.put(`invitation-confirmation/${lineData?._id?.toString()}/category_id`, { category_id: data?.category_id });
    await api.put(`invitation-confirmation/${lineData?._id?.toString()}/table`, { table: data?.table });

    await sendMail()
    removeLoading('loading')
  }


  const ChangeUser = () => {

    addModal({
      title: '', theme: 'whiteModalMedium', content: <>
        <h2 style={{ color: '#333', fontSize: '#333', width: '100%', textAlign: 'center' }}>Confirmar envio?</h2>

        <Form onSubmit={sendUserContent} initialData={{ ...lineData }}>

          <Input name="name" placeholder='Nome' />
          <Input name="email" placeholder='E-mail' />
          <Input name="category_id" placeholder='Categoria' />
          <Input name="company" placeholder='Empresa' />
          <Input name="position" placeholder='Cargo' />
          <Input name="table" placeholder='Mesa' />
          <button className='greenButton2' style={{ margin: '10px auto' }}  >Salvar e enviar</button>

        </Form>


      </>
    })

  }



  const moduleUpdate = (data: Record<string, any>): JSX.Element => (
    <button className='lineIcon' title='Alterar participante' onClick={() => { ChangeUser() }}><FaUser /></button>
  );

  return moduleUpdate(lineData);
}
